








































































import { Component, Prop, Vue } from "vue-property-decorator";
import { User } from "@/api/models/User";
import { UserPraesidiumEntry } from "@/api/models/UserPraesidiumEntry";
import { PraesidiumRole } from "@/api/models/PraesidiumRole";
import PraesidiumCardQuestions from "@/components/praesidium/PraesidiumCardQuestions.vue";
@Component({
    components: { PraesidiumCardQuestions }
})
export default class PraesidiumCard extends Vue {
    /**
     * Praesidium user to display.
     */
    @Prop()
    user: User;

    /**
     * Praesidium year to display.
     */
    @Prop()
    year: number;

    /**
     * If the dialog is open.
     */
    dialog = false;

    /**
     * Get the correct UserPraesidiumEntry entry based on the given year.
     */
    get praesidiumEntry(): UserPraesidiumEntry {
        const entry = this.user.praesidium.find(entry => entry.year === this.year);

        // Make sure the entry is present.
        if (!entry) {
            throw new Error(
                `No praesidium entry for user '${this.user.firstname} ${this.user.lastname}' for year ${this.year}`
            );
        }

        return entry;
    }

    /**
     * Get the praesidium role for the user.
     */
    get praesidiumRole(): PraesidiumRole {
        return require("@/api/content/praesidium/roles/" + this.praesidiumEntry.role);
    }
}
